// Nguồn sự thật duy nhất cho giá trị hợp lệ của cookie `region`.
//
// MVK-3037: cookie `region=null` đã lọt vào trình duyệt khách thật và làm rule WAF `SQLi_COOKIE`
// khớp — WAF đọc cụm `region=null; _ga` như một câu SQL (`<ident> = NULL ;`). Vì cookie đi kèm MỌI
// request, khách đó ăn 403 trên TOÀN SITE, và cookie có hạn 365 ngày nên họ không tự thoát được.
//
// Hai bản sao của `getRegion`/`setRegion` (assets/js/app.js và assets/js/utils/legacy-showtime-runtime.js)
// đều phải đi qua đây — chính việc có hai bản sao là thứ đã để lọt giá trị hỏng.

export const DEFAULT_REGION_ID = 1; // hcmc

/**
 * Chuẩn hoá một giá trị vùng bất kỳ về id dùng được.
 *
 * @param {*} value giá trị thô đọc từ cookie, từ `dataset`, hoặc từ `<select>`
 * @returns {number|null} id vùng hợp lệ, hoặc `null` nếu không dùng được
 *                        (`"null"`, `"undefined"`, chuỗi rỗng, số âm, không phải số…)
 */
export function normalizeRegionId(value) {
  const id = Number.parseInt(value, 10);

  return Number.isInteger(id) && id > 0 ? id : null;
}
